module.exports = __webpack_public_path__ + "MaterialIcons-Regular.e79bfd88537def476913.eot";


//////////////////
// WEBPACK FOOTER
// /app/src/assets/layout/fonts/MaterialIcons-Regular.eot
// module id = ../../../../../src/assets/layout/fonts/MaterialIcons-Regular.eot
// module chunks = 2